<template>
  <div class="container-rectangle" :style="styles">
    <apexcharts class="rectangle-chart" :series="data" :options="chartOptions" />
  </div>
</template>

<script>
import apexcharts from 'vue-apexcharts';
import global from '../../../mixins/global';

export default {
	components: {
		apexcharts,
	},
	mixins: [global],
	props: {
		interval: {
			type: Array,
			default: () => (
				['00/00', '00/00', '00/00', '00/00', '00/00']
			),
		},
		data: {
			type: Array,
			default: () => (
				[
					{
						name: 'Cancelados',
						data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
					},
					{
						name: 'Finalizados',
						data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
					},
					{
						name: 'Salvos',
						data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
					}
				]
			),
		},
		width: {
			type: String,
			default: '100%',
		},
		alignSelf: {
			type: String,
			default: 'center',
		},
		height: {
			type: String,
			default: '100%',
		},
		backgroundColor: {
			type: String,
			default: '#FFF',
		},
		padding: {
			type: String,
			default: '30px',
		},
		marginTop: {
			type: String,
			default: '0',
		},
		display: {
			type: String,
			default: 'flex',
		},
	},
	computed: {
		chartOptions() {
			const options = {
				colors: ['#f79824', '#2d00f7', '#d62828'],
				chart: {
					type: 'bar',
					height: '100%',
					width: '100%',
					toolbar: {
						show: false,
					}
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '35%',
						endingShape: 'rounded',
					},
				},
				dataLabels: {
					enabled: false
				},
				legend: {
					show: false,
				},
				stroke: {
					show: false,
					width: 2,
					colors: ['transparent']
				},
				xaxis: {
					categories: this.interval,
				},
				yaxis: {
					show: false,
				},
				fill: {
					opacity: 1
				},
				grid: { show: false, },
				tooltip: {
					y: {
						formatter(val) {
							return `${val.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
						}
					}
				}
			};
			return options;
		},
		styles() {
			return {
				width: this.width,
				height: this.height,
				backgroundColor: this.backgroundColor,
				marginTop: this.marginTop,
				display: this.display,
				padding: this.padding,
				alignSelf: this.alignSelf,
			};
		}
	}
};
</script>

<style scoped>
.rectangle-chart {
    width: 100%;
    height: 100%;
    display: flex;
}
.container-rectangle {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
}
</style>
